import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const StyledTypography = styled(Typography)({
  position: "absolute",
  bottom: "24px",
  right: "24px",
  zIndex: 0,
  fontWeight: 500,
  fontSize: 12,
});
